import { Directive, ElementRef, Input, HostBinding, Renderer2, AnimationPlayer, OnInit, ChangeDetectorRef } from '@angular/core';
import { ɵAnimation as Animation, AnimationDriver,
         ɵAnimationStyleNormalizer as AnimationStyleNormalizer, ɵDomAnimationEngine as DomAnimationEngine } from '@angular/animations/browser';
import { animate } from '@angular/animations';
export class TdToggleDirective {
private _state: boolean;
private _defaultOverflow: string;
private _defaultDisplay: string;
private _engine: DomAnimationEngine;
private _animationPlayer: AnimationPlayer;
/**
 * duration?: number
 * Sets duration of toggle animation in miliseconds.
 * Defaults to 150 ms.
 */
duration: number = 150;
/**
 * tdToggle: boolean
 * Toggles element, hides if its 'true', shows if its 'false'.
 * @param {?} state
 * @return {?}
 */
set state(state: boolean) {
    this._state = state;
    if (this._animationPlayer) {
      this._animationPlayer.destroy();
      this._animationPlayer = undefined;
    }
    if (state) {
      this.hide();
    } else {
      this.show();
    }
  }
/**
 * Binds native 'aria-expanded' attribute.
 * @return {?}
 */
get ariaExpandedBinding(): boolean {
    return !this._state;
  }
/**
 * Binds native 'aria-hidden' attribute.
 * @return {?}
 */
get ariaHiddenBinding(): boolean {
    return this._state;
  }
/**
 * @param {?} _renderer
 * @param {?} _element
 * @param {?} _changeDetectorRef
 * @param {?} animationDriver
 * @param {?} animationStyleNormalizer
 */
constructor(private _renderer: Renderer2,
private _element: ElementRef,
private _changeDetectorRef: ChangeDetectorRef,
              animationDriver: AnimationDriver,
              animationStyleNormalizer: AnimationStyleNormalizer) {
    this._engine = new DomAnimationEngine(animationDriver, animationStyleNormalizer);
  }
/**
 * Hides element: sets "display:[default]" so animation is shown,
 * starts animation and adds "display:'none'" style at the end.
 * @return {?}
 */
hide(): void {
    this._defaultDisplay = this._element.nativeElement.style.display;
    this._defaultOverflow = this._element.nativeElement.style.overflow;
    this._animationPlayer = this._engine.animateTimeline(
        this._element.nativeElement,
        new Animation([animate(this.duration + 'ms ease-out')],
      ).buildTimelines([{height: this._element.nativeElement.scrollHeight + 'px'}], [{height: 0}]));
    this._renderer.setStyle(this._element.nativeElement, 'overflow', 'hidden');
    this._changeDetectorRef.markForCheck();
    this._animationPlayer.play();
    this._animationPlayer.onDone(() => {
      this._animationPlayer.destroy();
      this._renderer.setStyle(this._element.nativeElement, 'overflow', this._defaultOverflow);
      this._renderer.setStyle(this._element.nativeElement, 'display', 'none');
      this._changeDetectorRef.markForCheck();
    });
  }
/**
 * Shows element: sets "display:[default]" so animation is shown,
 * starts animation and adds "overflow:[default]" style again at the end.
 * @return {?}
 */
show(): void {
    this._renderer.setStyle(this._element.nativeElement, 'display', this._defaultDisplay);
    this._changeDetectorRef.markForCheck();
    this._animationPlayer = this._engine.animateTimeline(
        this._element.nativeElement,
        new Animation([animate(this.duration + 'ms ease-in')],
      ).buildTimelines([{height: 0}], [{height: this._element.nativeElement.scrollHeight + 'px'}]));
    this._renderer.setStyle(this._element.nativeElement, 'overflow', 'hidden');
    this._animationPlayer.play();
    this._animationPlayer.onDone(() => {
      this._animationPlayer.destroy();
      this._renderer.setStyle(this._element.nativeElement, 'overflow', this._defaultOverflow);
      this._changeDetectorRef.markForCheck();
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[tdToggle]',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer2, },
{type: ElementRef, },
{type: ChangeDetectorRef, },
{type: AnimationDriver, },
{type: AnimationStyleNormalizer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'duration': [{ type: Input },],
'state': [{ type: Input, args: ['tdToggle', ] },],
'ariaExpandedBinding': [{ type: HostBinding, args: ['attr.aria-expanded', ] },],
'ariaHiddenBinding': [{ type: HostBinding, args: ['attr.aria-hidden', ] },],
};
}

function TdToggleDirective_tsickle_Closure_declarations() {
/** @type {?} */
TdToggleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdToggleDirective.ctorParameters;
/** @type {?} */
TdToggleDirective.propDecorators;
/** @type {?} */
TdToggleDirective.prototype._state;
/** @type {?} */
TdToggleDirective.prototype._defaultOverflow;
/** @type {?} */
TdToggleDirective.prototype._defaultDisplay;
/** @type {?} */
TdToggleDirective.prototype._engine;
/** @type {?} */
TdToggleDirective.prototype._animationPlayer;
/**
 * duration?: number
 * Sets duration of toggle animation in miliseconds.
 * Defaults to 150 ms.
 * @type {?}
 */
TdToggleDirective.prototype.duration;
/** @type {?} */
TdToggleDirective.prototype._renderer;
/** @type {?} */
TdToggleDirective.prototype._element;
/** @type {?} */
TdToggleDirective.prototype._changeDetectorRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
